import { faStar as faStarSolid } from "@fortawesome/free-solid-svg-icons";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

export type PinButtonProps = {
  pinned: boolean;
  onChange?: (pinned: boolean) => void;
};

export function PinButton(props: PinButtonProps) {
  const [pinned, setPinned] = useState<boolean>(props.pinned);
  const [hover, setHover] = useState<boolean>(false);

  function handleClick() {
    setHover(false);
    setPinned((prev) => !prev);
    if (props.onChange) {
      props.onChange(!pinned);
    }
  }

  return (
    <FontAwesomeIcon
      size="sm"
      icon={pinned || hover ? faStarSolid : faStar}
      onClick={handleClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      role="button"
      title="Favorite"
      className="text-primary"
      fixedWidth={true}
    />
  );
}
